import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import './AllRepaymentList.css'

const AllRepaymentList2UI = ({ accountList, prepaymentAccountList, totals, totalLoans, totalNonRFLoans, totalRFLoans, checked, onShowDetailsChange, view, onViewChange }) =>
  <div className='su_ac_rp_l'>
    <span className='g_flex_h g_flex_right'>
      <span className='g_muted g_small g_m_right_50 g_m_left_50'>
        Loan breakup
      </span>
      <SwitchUI checked={checked} onChange={onShowDetailsChange} />
    </span>
    <TableUI accountList={accountList} totals={totals} totalLoans={totalLoans} totalNonRFLoans={totalNonRFLoans} totalRFLoans={totalRFLoans} checked={checked} />
    <TableUI accountList={prepaymentAccountList} totals={totals} checked={checked} prepayment={true} />
  </div>

const TableUI = ({ accountList, totals, totalLoans, totalNonRFLoans, totalRFLoans, view, checked, prepayment }) =>
  <CardUI className={`${prepayment ? 'g_m_top_100' : 'g_m_top_50'} g_small`} title={prepayment ? 'Prepayments' : 'Monthly Repayments'}>
    {
      prepayment && <a name='prepayment' />
    }
    {
      true &&
      <table><thead className='g_sticky'>
        <tr className='head'>
          <td></td>
          <td className='left'>Account/Loan</td>
          {
            <>
              <td> Principal<br />
                <span className='g_muted'>paid</span>
              </td>
              {/* <td> Principal Paid </td> */}
              <td> Interest<br />
                <span className='g_muted'>paid</span>
              </td>
              <td>EMI<br />
                <span className='g_muted'>GST, </span>
                <i className='g_muted'>TDS</i>
              </td>
              {/* <td> Interest Paid </td> */}
              <td> Penal Charge(V2)<br />
                <span className='g_muted'>paid</span>
              </td>
              <td>Penal Charge(V1)</td>
              {/* <td> Penal Charge Paid </td> */}
              <td> Int on Overdue Principal <br />
                <span className='g_muted'>paid</span>
              </td>
              {/* <td> Int on Overdue Principal Paid </td> */}
              <td> Int on Overdue Int <br />
                <span className='g_muted g_m_left_100'>paid</span>
              </td>
              {/* <td> Int on Overdue Int Paid </td> */}
              <td>Total Due</td>
              <td>Total Paid(V2)</td>
              <td>Total Paid(V1)</td>
              <td>Pending</td>
            </>
          }
        </tr>
      </thead>
        <tbody>
          {
            accountList.map((account, i) =>
              <React.Fragment key={i}>
                <tr className={`acc ${account.balanceStatus === 'insufficient_balance' ? 'g_error' :
                  account.balanceStatus === 'with_dsra_dip' ? 'g_info' :
                    account.balanceStatus === 'sufficient_balance' ? 'g_success' : ''}`}>
                  <td className='left'>{i + 1}</td>
                  <td className1={`left ${account.totalDSRADipInterestF5 !== '0.00' || account.totalDefaultInterestF5 !== '0.00' ? 'g_error' : ''}`}>{account.accountName}</td>
                  {
                    <>
                      <td>{account.totalPrincipalF5}
                        {
                          account.totalPrincipalPaidV2 !== '0.00' &&
                          <>
                            <br />
                            <span className='g_muted'>{account.totalPrincipalPaidV2}
                            </span>
                          </>
                        }
                      </td>
                      {/* <td>{account.totalPrincipalPaidV2}</td> */}
                      <td>{account.totalInterestF5}
                        {
                          account.totalInterestPaidV2 !== '0.00' &&
                          <>
                            <br />
                            <span className='g_muted'>{account.totalInterestPaidV2}
                            </span>
                          </>
                        }
                      </td>
                      <td>{account.totalEMIF5}
                        <span className='g_muted'>{account.totalGSTF5 !== '0.00' && <><br />{account.totalGSTF5}</>}</span>
                        <i className='g_muted'>{account.totalTDSF5 !== '0.00' && <><br />{account.totalTDSF5}</>}</i>
                      </td>
                      {/* <td>{account.totalInterestPaidV2}</td> */}
                      <td>{account.totalDefaultInterestV2}
                        {
                          account.totalDefaultInterestPaidV2 !== '0.00' &&
                          <>
                            <br />
                            <span className='g_muted'>{account.totalDefaultInterestPaidV2}
                            </span>
                          </>
                        }
                      </td>
                      <td>{account.totalDefaultInterestF5}</td>
                      {/* <td>{account.totalDefaultInterestPaidV2}</td> */}
                      <td>{account.totalIntOnOverduePrV2} {
                        account.totalIntOnOverduePrPaidV2 !== '0.00' &&
                        <>
                          <br />
                          <span className='g_muted'>{account.totalIntOnOverduePrPaidV2}
                          </span>
                        </>
                      }
                      </td>
                      {/* <td>{account.totalIntOnOverduePrPaidV2}</td> */}
                      <td>{account.totalIntOnOverdueIntV2}
                        {
                          account.totalIntOnOverdueIntPaidV2 !== '0.00' &&
                          <>
                            <br />
                            <span className='g_muted'>{account.totalIntOnOverdueIntPaidV2}
                            </span>
                          </>
                        }
                      </td>
                      {/* <td>{account.totalIntOnOverdueIntPaidV2}</td> */}
                      <td>{account.totalPayableF5}</td>
                      <td>{account.totalPaidV2}</td>
                      <td>{account.totalPaidF5}</td>
                      <td>{account.totalPendingAmountV2 == null ? '0.00' : account.totalPendingAmountV2}</td>
                    </>
                  }
                </tr>

                {
                  checked && (
                    account.repaymentList && account.repaymentList.length > 0 ? (
                      account.repaymentList.map((repayment, repaymentIndex) => {
                        return (
                          <React.Fragment key={`repayment-${repaymentIndex}`}>
                            <tr className='loan g_muted'>
                              <td>{i + 1}.{repaymentIndex + 1}</td> {/* Index */}
                              <td className="left">
                                <Link to={`/su/loans/${repayment.loanId}/repayments/v2`}>
                                  {repayment.loanName} ({repayment.loanRefNum})
                                </Link>
                              </td>

                              <td>{repayment.principalF5}<br />
                                <span className='g_muted'>{repayment.principalPaidV2}</span></td>
                              {/* Principal Paid */}
                              {/* <td>{repayment.principalPaidV2}</td> */}

                              <td>{repayment.interestF5}<br />
                                <span className='g_muted'>{repayment.interestPaidV2}</span></td>
                              {/* Interest Paid */}
                              {/* <td>{repayment.interestPaidV2}</td> */}

                              <td></td>{/* EMI */}

                              {/* Default Interest */}
                              <td>{repayment.defaultInterestV2}<br />
                                <span className='g_muted'>{repayment.defaultInterestPaidV2}</span>
                              </td> {/* Default Interest */}

                              <td></td>{/* Penal Charge V1 */}
                              {/* Default Interest Paid */}
                              {/* <td>{repayment.defaultInterestPaidV2}</td> */}

                              {/* Interest on Overdue Principal */}
                              <td>{repayment.intOnOverduePrV2}<br />
                                <span className='g_muted'>{repayment.intOnOverduePrPaidV2}</span></td> {/* Interest on Overdue Principal */}

                              {/* Interest on Overdue Principal Paid */}
                              {/* <td>{repayment.intOnOverduePrPaidV2}</td> */}

                              {/* Interest on Overdue Interest */}
                              <td>{repayment.intOnOverdueIntV2}<br />
                                <span className='g_muted'>{repayment.intOnOverdueIntPaidV2}</span></td> {/* Interest on Overdue Interest */}

                              {/* Interest on Overdue Interest Paid */}
                              {/* <td>{repayment.intOnOverdueIntPaidV2}</td> */}

                              {/* Remaining Due */}
                              <td>{repayment.payableF5}</td>
                              {/* Paid */}
                              <td>{repayment.paidV2}</td> {/* Paid */}
                              <td>{repayment.paidF5}</td>
                              <td>{repayment.pendingAmountV2 === null ? '0.00' : repayment.pendingAmountV2}</td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td></td>
                        <td colSpan="14" className="g_muted g_small">No Repayments</td>
                      </tr>
                    )
                  )
                }

                {
                  !checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      {
                        repayment.prepaymentAmountF5 &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_info'>Prepaid loan {repayment.loanName}, amount: {repayment.prepaymentAmountF5}</td>
                        </tr>
                      }
                      {/*
              repayment.dsraDipInterestFormula &&
              <tr>
                <td></td>
                <td colSpan='20' className='g_muted g_small limit'>DSRA Int: {repayment.dsraDipInterestFormula}</td>
              </tr>
            */}
                      {/*
              repayment.defaultInterestFormula &&
              <tr>
                <td></td>
                <td colSpan='20' className='g_muted g_small'>Default Int: {repayment.defaultInterestFormula}</td>
              </tr>
            */}
                    </React.Fragment>
                  )
                }
                {
                  !view && checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      {
                        repayment.defaultHistoryList && repayment.defaultHistoryList.length > 0 &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_muted g_small'>
                            {
                              repayment.defaultHistoryList.map((d, i) =>
                                <span key={i} className='g_flex_v'>
                                  Default date: {d.defaultDateF1}, cure date: {d.cureDateF1}
                                  {
                                    d.defaultReason &&
                                    <span className='g_muted'>Default reason: {d.defaultReason}</span>
                                  }
                                </span>
                              )
                            }
                          </td>
                        </tr>
                      }
                    </React.Fragment>
                  )
                }
                {
                  checked && account.repaymentList.map((repayment, j) =>
                    <React.Fragment key={j}>
                      {
                        repayment.remarks &&
                        <tr>
                          <td></td>
                          <td colSpan='20' className='g_muted g_small'>Remarks: {repayment.remarks}</td>
                        </tr>
                      }
                    </React.Fragment>
                  )
                }
              </React.Fragment>
            )
          }
          <tr className='foot'>
            <td></td>
            <td className='left'>Total</td>
            {!prepayment &&
              <>
                <td>{totals.totalPrincipalF5}</td>
                {/* <td>{totals.totalPrincipalPaidV2}</td> */}
                <td>{totals.totalInterestF5}</td>
                <td>{totals.totalEMIF5}</td>
                {/* <td>{totals.totalInterestPaidV2}</td> */}
                <td>{totals.totalDefaultInterestV2}</td>
                <td>{totals.totalDefaultInterestF5}</td>
                {/* <td>{totals.totalDefaultInterestPaidV2}</td> */}
                <td>{totals.totalIntOnOverduePrV2}</td>
                {/* <td>{totals.totalIntOnOverduePrPaidV2}</td> */}
                <td>{totals.totalIntOnOverdueIntV2}</td>
                {/* <td>{totals.totalIntOnOverdueIntPaidV2}</td> */}
                <td>{totals.totalPayableF5}</td>
                <td>{totals.totalPaidV2}</td>
                <td>{totals.totalPaidF5}</td>
                <td>{totals.totalPendingAmountV2 === null ? '0.00' : totals.totalPendingAmountV2}</td>
              </>
            }
            {
              !view && prepayment &&
              <>
                <td />
                <td />
                <td />
                <td />
                <td />
                <td>{totals.totalPrePaidAmountF5}</td>
                <td />
                <td>{totals.totalPrePaidAmountF5}</td>
                <td />
                {/* <td>{totals.totalBalanceAfterPayment}</td> */}
              </>
            }
          </tr>
        </tbody></table>
    }
    {
      totalLoans &&
      <div className='g_flex_h'>
        <div className='text-bold'>
          <p>Total number of loans: {totalLoans}</p>
          <p>Total Non-RF loans: {totalNonRFLoans}</p>
          <p>Total RF loans: {totalRFLoans}</p>
        </div>

        <div className='g_m_left_100'>
          <p className='g_error'>Red: Insufficient balance</p>
          <p className='g_info'>Blue: Dsra dip</p>
          <p className='g_success'>Green: Sufficient balance</p>
        </div>
      </div>
    }
  </CardUI >

export default AllRepaymentList2UI
